import { useState } from "react"
import { useTranslation } from "next-i18next"

import SelectedProductListUI from "@/components/MultiFinshProductBundle/ui/SelectedProductListUI"
import { getTranslations } from "@/components/Bundles/localization"
import { getSelectedProductData } from "./utils"
import { selectedProductListAnalytics } from "@/components/MultiFinshProductBundle/analytics"

const BundleSelectedProductList = props => {
  const {
    config = {},
    finalProductPrice = 0,
    isPriceLoading = true,
    bundleItems = [],
    skusPrice = [],
    selectedProducts = [],
    productInfoBundle = [],
  } = props || {}
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation("common")

  const { internationalization: { currencySign = "$" } = {} } = config

  const productData = getSelectedProductData({
    bundleItems,
    selectedProducts,
    skusPrice,
  })

  const noOfChildItems = productData?.length ?? 0
  const staticTexts = getTranslations(t)

  const handleIsOpen = () => {
    const accordianAction = isOpen ? "collapse" : "expand"
    selectedProductListAnalytics(productInfoBundle, accordianAction)
    setIsOpen(prevState => !prevState)
  }

  return (
    <SelectedProductListUI
      productData={productData}
      noOfChildItems={noOfChildItems}
      currency={currencySign}
      staticTexts={staticTexts}
      isOpen={isOpen}
      handleIsOpen={handleIsOpen}
      isPriceLoading={isPriceLoading}
      finalProductPrice={finalProductPrice}
    />
  )
}

export default BundleSelectedProductList
